<script lang="ts" setup>
import { noExponents, numberWithCommas } from '@/utils';
import { isNull, isUndefined } from 'lodash';
import Badge from "primevue/badge"
import Skeleton from "primevue/skeleton"

const props = defineProps<{
  exchange: string | undefined
  titleHref: string | undefined
  price: number | null | undefined
  vol: number | null | undefined
  priceClass?: string | null,
  loading: boolean
  class?: string | string[]
}>()
</script>

<template>
  <template v-if="loading || !exchange">
    <Skeleton height="24px" class="ms-2" width="60px" style="padding: 9px;">
    </Skeleton>
    <Skeleton height="24px" class="ms-2" width="60px" style="padding: 9px;">
    </Skeleton>
  </template>
  <template v-else>
    <div class="pit">
      <a v-if="exchange" :href="titleHref" target="_blank" :class="props.class" class="capitalize">{{ exchange }}</a>
      <template v-if="isNull(price) || isUndefined(price) || isNaN(price) || price == 0">
        <Badge v-tooltip.bottom="$t('cexDataBrokenError')" class="ms-2" severity="danger">!!!</Badge>
      </template>
      <template v-else>
        <span class="ms-2 sr-eye-price digit" :class="priceClass">{{ noExponents(price) }}</span>
        <span v-if="vol" class="ms-2 sr-eye-amount">${{ numberWithCommas(Number(vol).toFixed(0)) }}</span>
      </template>
    </div>
    <slot name="right">
    </slot>
  </template>
</template>
